import { toast } from 'react-toastify';

import {
  getContracts,
  cancelContract,
} from '../api/bernabeu';

import {
  callTypes,
  contractSlice
} from "../../redux/reducers/contractSlice";

const { actions } = contractSlice;

type ContractType = 'single' | 'recurrence';

const fetchContracts = (modality: string = '', type: ContractType | '' = '', isActive: boolean | null = null) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    let params: any = {};

    if (modality) {
      params.modality = modality;
    }

    if (type) {
      params.type = type;
    }

    if (isActive !== null) {
      params.is_active = isActive ? 1 : 0;
    }

    getContracts(params).then((response: any) => {
      dispatch(actions.contractsFetched());

      resolve(response.data);
    }).catch((error) => {
      console.log('fetchContracts falhou:');
      console.log({ error });

      dispatch(actions.catchError({ error, callType: callTypes.list }));

      reject(new Error('Erro ao buscar contratos'));
    });
  });
}

const fetchContract = (id) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    getContracts({ id: id }).then((response: any) => {
      dispatch(actions.contractsFetched());

      resolve(response.data[0]);
    }).catch((error) => {
      console.log('fetchContract falhou:');
      console.log({ error });

      dispatch(actions.catchError({ error, callType: callTypes.list }));

      reject(new Error('Erro ao buscar contrato'));
    });
  });
}

const fetchCancelContract = (contractId) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    cancelContract(contractId, {}).then((response: any) => {
      dispatch(actions.contractCanceled());

      resolve(true);
    }).catch((error) => {
      console.log('fetchCancelContract falhou:');
      console.log({ error });

      dispatch(actions.catchError({ error, callType: callTypes.action }));

      let message = error.response?.data?.message ?? 'Erro ao cancelar contrato';

      toast.error(message);

      reject(new Error(message));
    });
  });
}

export {
  fetchContract,
  fetchContracts,
  fetchCancelContract,
};
